module.exports = __webpack_public_path__ + "static/STJCloud_Logo_White_NoTagline-b38a71b1da2c300f3cdee806d1cf7753.png";